// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEditSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PEditSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PEditSquareOutlined = function PEditSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEditSquareOutlinedSvg
  }));
};

PEditSquareOutlined.displayName = 'PEditSquareOutlined';
export default React.forwardRef(PEditSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEditSquareOutlined.js
// module id = 3351
// module chunks = 0